import {
  selectOption,
  setCalculationEnabled,
  invalidateCalculation,
} from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import { ActionTypes } from './types';

interface CustomData {
  [name: string]: string | number | object;
}

export const setCustomData = (payload: CustomData) => ({
  type: ActionTypes.SET_CUSTOM_DATA,
  payload,
});

export const resetConfiguration = () => ({
  type: ActionTypes.RESET_CONFIGURATION,
});

const prepareCustomDataPayload = (component, option) => {
  const result = { [component.identifier]: option.identifier };
  if (component.identifier === 'length') {
    Object.assign(result, { surrounding_length: Math.ceil(parseFloat(option.identifier) / 5) * 5 + 10 });
  }
  return result;
};

export const selectSystemParameterOption = (component, option) => (dispatch) => {
  dispatch(setCustomData(prepareCustomDataPayload(component, option)));
  return dispatch(selectOption({ ...option, amount: option.amount ? 0 : 1 }, false, false, component));
};

export const setOptionUserInputValue = (component, option, inputText) =>
  selectOption({ ...option, inputText }, false, false, component);

export const selectSystemParameterOptionSync = (() => {
  let lastPromise = Promise.resolve();
  let count = 0;
  return (component, option, inputText?: string) => (dispatch, getState) => {
    getState().configurator.calculationIsEnabled && dispatch(setCalculationEnabled(false));
    count++;
    lastPromise = lastPromise
      .then(() =>
        dispatch(
          inputText !== undefined
            ? setOptionUserInputValue(component, option, inputText)
            : selectSystemParameterOption(component, option)
        )
      )
      .finally(() => {
        count--;
        if (count === 0) {
          dispatch(setCalculationEnabled(true));
          dispatch(invalidateCalculation());
        }
      });
  };
})();

export const setSurroundingData = (componentIdentifier, value) =>
  setCustomData({ [componentIdentifier]: value });

export const selectOptionSync = (() => {
  let lastPromise = Promise.resolve();
  let count = 0;
  return (option, component, inputText?: string) => (dispatch, getState) => {
    getState().configurator.calculationIsEnabled && dispatch(setCalculationEnabled(false));
    count++;
    lastPromise = lastPromise
      .then(() =>
        dispatch(
          inputText !== undefined
            ? setOptionUserInputValue(component, option, inputText)
            : selectOption(option, false, false, component)
        )
      )
      .finally(() => {
        count--;
        if (count === 0) {
          dispatch(setCalculationEnabled(true));
          dispatch(invalidateCalculation());
        }
      });
  };
})();
